import { CONDITION_CODES } from '../../../data/conditionCodes';
import { CodeListField } from '../claimWorksheet/CodeListField';

export function ConditionCodesField({
  values,
  onChange,
  readOnly = false,
}: {
  values: string[];
  onChange: (next: string[]) => void;
  readOnly?: boolean;
}) {
  return (
    <CodeListField
      label='Condition Code'
      showLabel={false}
      options={CONDITION_CODES}
      values={values}
      onChange={onChange}
      disabled={readOnly}
    />
  );
}
